export default "/images/shuffle.svg?60f9614fd584355aa03b9d5ffcc3b395";